import React, { useEffect, useState } from "react";
import InputField from "./InputField";
import Tag from "./Tag";

const InvoiceModal = ({ invoice, onClose, onSave, tags }) => {
	const [newDate, setNewDate] = useState(invoice?.date?.substring(0, 10) || "");
	const [newDescr, setNewDescr] = useState(invoice?.descr || "");
	const [newImporto, setNewImporto] = useState(invoice?.importo || "");
	const [selectedTags, setSelectedTags] = useState(invoice?.tags || []);
	const [allTags, setAllTags] = useState(tags);
	const [file, setFile] = useState(null);
	const [error, setError] = useState(null);

	const updateAllTags = () => {
		let sel = selectedTags.map((tag) => tag.id);
		let newTags = tags.filter((tag) => !sel.includes(tag.id));
		setAllTags(newTags);
	};

	useEffect(updateAllTags, [selectedTags]);

	const handleClose = () => {
		onClose();
	};

	const handleSaveEdit = () => {
		if (!newDate || !newDescr || !newImporto || (!file && !invoice)) {
			setError("Tutti i campi sono obbligatori.");
			return;
		}
		const newInvoice = {
			...invoice,
			date: newDate,
			descr: newDescr,
			importo: newImporto,
			tags: selectedTags,
		};

		if (file) newInvoice.file = file;

		onSave(newInvoice);
	};

	const handleTagSelection = (tagId) => {
		let newTags = allTags.filter((tag) => tag.id === tagId);
		let selected = [...selectedTags, newTags[0]];
		setSelectedTags(selected);
	};

	const handleTagDeselection = (tagId) => {
		let selected = selectedTags.filter((tag) => tag.id !== tagId);
		setSelectedTags(selected);
	};

	const handleFileChange = (e) => {
		const selectedFile = e.target.files[0];
		if (selectedFile) {
			setFile(selectedFile);
		}
	};

	return (
		<div className="modal is-active">
			<div className="modal-background" onClick={handleClose}></div>
			<div className="modal-content">
				<div className="box">
					<h2 className="subtitle">{invoice ? "Modifica Fattura" : "Crea Fattura"}</h2>
					<InputField label="Data" type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
					<InputField
						placeholder="Descrizione Acquisto"
						label="Descrizione"
						type="text"
						value={newDescr}
						onChange={(e) => setNewDescr(e.target.value)}
					/>
					<InputField
						placeholder="Importo Acquisto"
						label="Importo (EURO)"
						type="number"
						value={newImporto}
						onChange={(e) => setNewImporto(e.target.value)}
					/>

					{!invoice && (
						<div className="field mb-5">
							<InputField type="file" label="Carica PDF" accept="application/pdf" onChange={handleFileChange} />
						</div>
					)}

					<div className="mb-5">
						<p className="is-size-5 has-text-centered mb-2">Tag Selezionati</p>
						<div className="tags is-centered">
							{selectedTags.length > 0 ? (
								selectedTags.map((tag) => (
									<Tag key={tag.id} text={tag.tag} hex_color={tag.hex_color} id={tag.id} onClick={handleTagDeselection} />
								))
							) : (
								<p className="is-small help">Non ci sono tag disponibili</p>
							)}
						</div>
					</div>
					<div className="mb-5">
						<p className="is-size-5 has-text-centered mb-2">Tag Disponibili</p>
						<div className="tags is-centered">
							{allTags.length > 0 ? (
								allTags.map((tag) => (
									<Tag key={tag.id} text={tag.tag} hex_color={tag.hex_color} id={tag.id} onClick={handleTagSelection} />
								))
							) : (
								<p className="is-small help">Non ci sono tag disponibili</p>
							)}
						</div>
					</div>

					{error && <p className="help is-danger is-size-4 has-text-centered mb-3">{error}</p>}

					<div className="control has-text-right">
						<button className="button is-secondary mr-2" onClick={handleClose}>
							Annulla
						</button>
						<button className="button is-primary" onClick={handleSaveEdit}>
							{invoice ? "Salva Modifiche" : "Crea Fattura"}
						</button>
					</div>
				</div>
			</div>
			<button className="modal-close is-large" onClick={handleClose}></button>
		</div>
	);
};

export default InvoiceModal;
